import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { PrimaryGuard } from './auth/guards/primary.guard';
import { TenantGuard } from './auth/guards/tenant.guard';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { WebLordGuard } from './auth/guards/web-lord.guard';
import { Tenant404PageComponent } from './pages/tenant-404-page/tenant-404-page.component';
import { LocationsPageComponent } from './pages/locations-page/locations-page.component';
import { ReservationComponent } from './reservation-page/pages/reservation-page/reservation-page.component';
import { ReservationConfirmationComponent } from './reservation-confirmation-page/reservation-confirmation-page.component';
import { RedirectPageComponent } from './pages/redirect-page/redirect-page.component';
import { TermsPageComponent } from './support/pages/terms-page/terms-page.component';
import { TermsLandingPageComponent } from './support/pages/terms-landing-page/terms-page.component';
import { PoliciesLandingPageComponent } from './pages/policies-page/policies-page.component';
import { DataPrivacyContactPageComponent } from './data-privacy-contact/data-privacy-contact-page.component';
import { ReservationIframeComponent } from './reservation-page/pages/reservation-iframe/reservation-iframe.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { LoginLandingPageComponent } from './shared/components/login-landing-page/login-landing-page.component';
import { AnnouncementsComponent } from './pages/announcements/announcements.component';
// import { MyFavoritesPageComponent } from './store/components/myfavorites-page/myfavorites-page.component';
// import { MyFavoritesPageAddContactsComponent }from './store/components/myfavorites-page/myfavorites-page-contacts/myfavorites-page-add-contacts/myfavorites-page-add-contacts.component';
// import { MyFavoritesPageEditContactsComponent }from './store/components/myfavorites-page/myfavorites-page-contacts/myfavorites-page-edit-contacts/myfavorites-page-edit-contacts.component';
// import { MyFavoritesPageEditUserComponent }from './store/components/myfavorites-page/myfavorites-page-contacts/myfavorites-page-edit-user/myfavorites-page-edit-user.component';
// import { CartModalComponent }from'./store/modals/cart/cart-modal.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomePageComponent,
    canActivate: [TenantGuard]
  },
  // this one is to make people login before actually accessing the app
  {
    path: 'login-home',
    component: LoginLandingPageComponent,
    canActivate: [TenantGuard]
  },
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [WebLordGuard],
    pathMatch: 'full'
  },
  {
    path: 'error-page',
    component: Tenant404PageComponent
  },
  
  // {
  //   path: 'myfavorites',
  //   component: MyFavoritesPageComponent,
  //   canActivate: [TenantGuard, AuthGuard]
  // },
  // {
  //   path: 'myfavoritesaddcontacts',
  //   component: MyFavoritesPageAddContactsComponent,
  //   canActivate: [TenantGuard, AuthGuard]
  // },
  // {
  //   path: 'myfavoriteseditcontacts/:id',
  //   component: MyFavoritesPageEditContactsComponent,
  //   canActivate: [TenantGuard, AuthGuard]
  // },
  // {
  //   path: 'myfavoritesedituser/:id',
  //   component: MyFavoritesPageEditUserComponent,
  //   canActivate: [TenantGuard, AuthGuard]
  // },
   {
    path: 'home/:language',
    component: HomePageComponent,
    canActivate: [TenantGuard]
  },

  {
    path: 'messages',
    component: MessagesComponent,
    canActivate: [TenantGuard]
  },

  // {
  //   path:'cart',
  //   component:CartModalComponent
  // },

  {
    path: 'data-privacy-contact',
    component: DataPrivacyContactPageComponent
  },
  {
    path: 'data-privacy-contact/:language',
    component: DataPrivacyContactPageComponent
  },
  {
    path: 'locations',
    component: LocationsPageComponent
  },
  {
    path: 'reservation',
    component: ReservationComponent
  },
  ////////////////////////////////////////////////////////////
  // recently added
  {
    path: 'reservation-iframe',
    component: ReservationIframeComponent
  },
  ////////////////////////////////////////////////////////////
  {
    path: 'announcements',
    component: AnnouncementsComponent
  },
  {
    path: 'confirmation/:reservationId',
    component: ReservationConfirmationComponent
  },
  {
    path: 'locations/:language',
    component: LocationsPageComponent
  },
  {
    path: 'stores',
    loadChildren: () => import('./store/store.module')
      .then(m => m.StoreModule),
      canActivate: [TenantGuard, PrimaryGuard]
  },
  
  /*{
    path: 'reservation',
    loadChildren: ()=>import('./reservation/reservation.module').then(m=>m.ReservationModule)
  },*/
  {
    path: 'order',
    loadChildren: () => import('./order/order.module')
      .then(m => m.OrderModule)
  },
  {
    path: 'shipping',
    loadChildren: () => import('./order-shipping/order-shipping.module')
      .then(m => m.OrderShippingModule)
  },
  {
    path: 'waitlist',
    loadChildren: () => import('./waitlist/waitlist.module')
      .then(m => m.WaitlistModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./table-menu/table-menu.module')
      .then(m => m.TableMenuModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./support/support.module')
      .then(m => m.SupportModule),
    canActivate: [TenantGuard]
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module')
      .then(m => m.AccountModule),
    canActivate: [TenantGuard, AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module')
      .then(m => m.AuthModule),
    canActivate: [TenantGuard]
  },

  /*
  {
    path: 'chat',
    loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule),
    canActivate: [TenantGuard, AuthGuard]
  }*/
  
  {
    path: 'terms',
    component: TermsLandingPageComponent
  },
  {
    path: 'terms/:language',
    component: TermsLandingPageComponent
  },
  {
    path: 'policies',
    component: PoliciesLandingPageComponent
  },
  {
    path: 'policies/:language',
    component: PoliciesLandingPageComponent
  }/*,

  {
    path: ':redirectWaitlistId',
    component: RedirectPageComponent
  }*/
];

@NgModule({
  imports: [
    //RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    RouterModule.forRoot(routes, {
      preloadingStrategy:
      PreloadAllModules,
      enableTracing: false
    })
  ],
  
  exports: [RouterModule]
})
export class AppRoutingModule {}
